
/**
 * Removes any editor specific values
 * @param {object} screenState
 * @returns {object}
 */
function pruneScreenState(screenState){
  var newScreenState = Object.assign({}, screenState), changed = false
  Object.entries(screenState).forEach(([key, field]) => {
    if (field.type == 'page' || field.type == 'form') return

    var fieldClone = Object.assign({}, field)
    newScreenState[key] = fieldClone
    ;['showCheckbox', 'checkboxSelected', 'selected'].forEach(pruneKey => {
      if (pruneKey in fieldClone){
        delete fieldClone[pruneKey]
        changed = true
      }
    })
  })
  return changed ? newScreenState : screenState
}

export default pruneScreenState


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/pruneScreenState.js